import type { LeaderboardPeriod, LeaderboardResponse } from '@beast-keeper/shared';
import { api } from './api';

/** 获取排行榜 */
export async function fetchLeaderboard(
  period: LeaderboardPeriod = 'all',
  limit = 100,
): Promise<LeaderboardResponse> {
  const res = await api.get('/leaderboard', { params: { period, limit } });
  return res.data;
}
